import { VIEW_ONLY_MODE } from '@domains/kyc';

// The KYC mode header lives in @domains/kyc so components there (e.g. UploadComponent) can attach
// it to their own requests; re-exported here for the app's API helpers.
export { KYC_MODE_HEADER, VIEW_ONLY_MODE, kycModeHeaders } from '@domains/kyc';

export const claimSessionURL = (
  sessionId: string,
  sessionAccess: string,
): string =>
  `/v1/claim_session/${encodeURIComponent(sessionId)}/${encodeURIComponent(sessionAccess)}`;

// Requires a literal "form/" prefix — a bare dynamic segment at the root would shadow
// static assets (ONMON-5814).
const FORM_PATH_PATTERN =
  /^form\/(?<formType>[^/]+)\/(?:(?<role>[^/]+)\/)?(?<submissionId>[^/]+)\/(?<token>[^/]+)\/?$/;

export const getSessionInfo = (): {
  id: string;
  access: string;
  sessionFormType: string;
  sessionMode: string;
  role: string | undefined;
} => {
  let formType = '';
  let id = 'unknown';
  let access = 'unknown';
  let sessionMode = '';
  let role: string | undefined;

  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    sessionMode = params.get('view_only') === 'true' ? VIEW_ONLY_MODE : '';

    const basePath = process.env.PATH_PREFIX || '';
    const relativePath = window.location.pathname
      .slice(basePath.length)
      .replace(/^\//, '');
    const pathMatch = relativePath.match(FORM_PATH_PATTERN);

    if (pathMatch?.groups) {
      formType = pathMatch.groups.formType ?? formType;
      id = pathMatch.groups.submissionId ?? id;
      access = pathMatch.groups.token ?? access;
      role = pathMatch.groups.role;
    } else {
      id = params.get('id') ?? id;
      access = params.get('access') ?? access;
      formType = params.get('formType') ?? formType;
      role = params.get('role') ?? undefined;
    }
  }

  return { id, access, sessionFormType: formType, sessionMode, role };
};
